import { Images, PermissionList, RolePermission } from 'utils';
import { DateRow, LinkRow, LocalDateRow, TextRow } from '../table';
import { AddClientAuthorization } from '../../fragments/client/clientModals';
import { EditWithIcon } from '../buttons';
import React from 'react';

// Notes Table config

export const noteHead = (permissions) => {
    return [
        { rowName: 'title', name: 'template', title: 'Form Title', custom: false },
        { name: 'description', title: 'Form Description', custom: false, disabled: true },
        { name: 'created', title: 'Created Date', icon: 'date', disabled: true },
        { name: 'creatorFullName', title: 'Creator Name', custom: false },
        RolePermission([...permissions]) && { name: 'action', title: 'Action', custom: false, disabled: true, width: '200px' },
    ];
};

export const noteBody = (permissions, userInfo) => {
    return [
        { rowText: (item) => <TextRow name={item?.template?.title} /> },
        { rowText: (item) => <TextRow name={item?.template?.description} /> },
        { rowText: (item) => <LocalDateRow date={item?.created} /> },
        // { rowText: (item) => <DateRow date={item?.created} /> },
        {
            rowText: (item) => (
                <LinkRow
                    name={item?.creatorFullName ? item?.creatorFullName : '--'}
                    href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.creatorId}` : ''}
                    checkPermission={item?.creatorFullName ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                    textWidth={8}
                />
            ),
            notClickable: true,
        },

        RolePermission([...permissions]) && {
            button: (cb, item) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <EditWithIcon
                        styles={{ opacity: item?.creatorId !== userInfo?.id ? 0.5 : 1 }}
                        disabled={item?.creatorId !== userInfo?.id}
                        icon={Images.showEye}
                        type={'button'}
                        handleClick={() => cb('viewHistory')}
                    />
                    <EditWithIcon
                        styles={{ opacity: item?.creatorId !== userInfo?.id ? 0.5 : 1 }}
                        disabled={item?.creatorId !== userInfo?.id}
                        icon={Images.editAuth}
                        type={'button'}
                        handleClick={() => cb('editNote')}
                    />
                    <EditWithIcon
                        styles={{ opacity: item?.creatorId !== userInfo?.id ? 0.5 : 1 }}
                        disabled={item?.creatorId !== userInfo?.id}
                        icon={Images.deleteTag}
                        type={'button'}
                        handleClick={() => cb('deleteNote')}
                    />
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const ACTION_TYPE = 'GET_GLOBAL_NOTES';

export const noteNotYet = {
    title: 'No Notes Yet',
    subTitle: 'Keep important details here by adding a note.',
    image: Images.noNote,
};
